import SDK from '@/docs-partials/sdk';
import * as React from 'react';
export default {
  SDK,
  React
};